var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.543 22.6572C11.8154 22.8945 12.1934 22.9297 12.4658 22.666L15.1729 19.9502C15.4365 19.6865 15.4277 19.2822 15.1641 19.0273L13.6611 17.5244L15.7969 15.3975C16.0518 15.1426 16.043 14.7383 15.7793 14.4746L13.7314 12.4092C16.2539 11.3105 17.6689 9.35059 17.6689 7.0127C17.6689 3.88379 15.1377 1.36133 12 1.36133C8.85352 1.36133 6.33105 3.875 6.33105 7.0127C6.33105 9.32422 7.68457 11.3809 9.82031 12.2598V20.6357C9.82031 20.873 9.89062 21.1543 10.1104 21.3389L11.543 22.6572ZM12 21.585L10.9102 20.4951V11.4775C8.84473 10.959 7.41211 9.15723 7.41211 7.0127C7.41211 4.49023 9.45996 2.45117 12 2.45117C14.5312 2.45117 16.5703 4.48145 16.5703 7.0127C16.5703 9.13086 15.1377 10.959 12.7295 11.5918V12.9805L14.6982 14.9492L12.668 16.9531V18.0781L14.083 19.4756L12 21.585ZM12 7.02148C12.8613 7.02148 13.5645 6.32715 13.5645 5.46582C13.5645 4.60449 12.8613 3.90137 12 3.90137C11.1299 3.90137 10.4355 4.5957 10.4355 5.46582C10.4355 6.32715 11.1387 7.02148 12 7.02148Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.984965b9caa3e2088b47c6f009ce3e82.svg";
export { ForwardRef as ReactComponent };